import type { TemplateRef } from '@angular/core';
import { Injectable, computed, signal } from '@angular/core';

export interface SidebarPortalContent {
    readonly template: TemplateRef<unknown>;
    readonly context?: Record<string, unknown>;
}

@Injectable({ providedIn: 'root' })
export class SidebarPortalService {
    private readonly _content = signal<SidebarPortalContent | null>(null);
    readonly content = this._content.asReadonly();
    readonly hasContent = computed(() => this._content() !== null);

    attach(
        template: TemplateRef<unknown>,
        context?: Record<string, unknown>
    ): void {
        this._content.set({ template, context });
    }

    detach(): void {
        this._content.set(null);
    }
}
